module.exports = new __parcel__URL__("report-average-age.f0063cee.svg").toString();